import { To } from 'react-router';

export const isExternalUrl = (url?: To) => {
    const href = typeof url === 'string' ? url : url?.pathname;
    if (!href) {
        return false;
    }

    const temporaryAnchor = document.createElement('a');
    temporaryAnchor.href = href;
    const isExternal = temporaryAnchor.host !== window.location.host;
    temporaryAnchor.remove();
    return isExternal;
};
